import type { Draft } from "@heraion/shared";

import type { TFn } from "../i18nTypes";

/** Each superset's label in day `sIdx`: its stored name (written here, by the
 *  old editor or by the connector), else "Superset 1", "Superset 2" in the
 *  order the groups appear in the day. */
export function groupLabels(draft: Draft, sIdx: number, t: TFn): Map<string, string> {
  const out = new Map<string, string>();
  let n = 0;
  for (const slot of draft.sessions[sIdx]?.slots ?? []) {
    if (!slot.group || out.has(slot.group.id)) continue;
    n += 1;
    const name = slot.group.name?.trim();
    out.set(slot.group.id, name || t("editorV3.supersetN", { n, defaultValue: "Superset {{n}}" }));
  }
  return out;
}
